import React from 'react';
import { Badge } from '../ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';

export const AdvertenciaBadge = ({ texto }) =>
  texto ? <Badge className="bg-amber-100 text-amber-800 text-[10px] whitespace-nowrap">{texto}</Badge> : null;

export const PreviewTabla = ({ titulo, columnas, filas, testid }) => {
  if (!filas.length) return null;
  return (
    <div data-testid={testid}>
      <p className="text-sm font-medium text-slate-700 mb-2">{titulo} ({filas.length})</p>
      <div className="max-h-80 overflow-auto rounded-lg border">
        <Table>
          <TableHeader className="sticky top-0 bg-slate-50 z-10">
            <TableRow>
              {columnas.map((c) => <TableHead key={c.key} className="text-xs whitespace-nowrap">{c.label}</TableHead>)}
            </TableRow>
          </TableHeader>
          <TableBody>
            {filas.map((f, i) => (
              <TableRow key={i} data-testid={`${testid}-row-${i}`}>
                {columnas.map((c) => (
                  <TableCell key={c.key} className="text-xs py-1.5 align-top">
                    {c.render ? c.render(f) : (f[c.key] ?? '—')}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};
